export enum RecurringInvoicesTableAccessor {
  Status = 'status',
  Customer = 'customer',
  Date = 'createdAt',
  FirstInvoice = 'startDate',
  Frequency = 'frequency',
  NextInvoice = 'nextInvoice',
  LastInvoice = 'lastInvoice',
  GrossTotal = 'grossTotal',
}
